import { TeleradiologyAPI } from 'app/interfaces/TeleradiologyAPI';
import React from 'react';

const TeleradiologyAPIContext = React.createContext<TeleradiologyAPI>(undefined);
export default TeleradiologyAPIContext;
